import dayjs from 'dayjs'
require('dayjs/locale/fr')
const advancedFormat = require('dayjs/plugin/advancedFormat')
// const weekday = require('dayjs/plugin/weekday')
// const weekOfYear = require('dayjs/plugin/weekOfYear')

dayjs.locale('fr')
dayjs.extend(advancedFormat)
// dayjs.extend(weekday)
// dayjs.extend(weekOfYear)
